import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const WishlistContext = createContext(null);
const STORAGE_KEY = 'hwl_wishlist_v1';

export const WishlistProvider = ({ children }) => {
  const [ids, setIds] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setIds(JSON.parse(raw));
    } catch (e) { console.error('Failed to load wishlist from localStorage', e); }
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }, [ids]);

  const isWishlisted = useCallback((id) => ids.includes(id), [ids]);

  const toggle = useCallback((id) => {
    setIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  }, []);

  const remove = useCallback((id) => {
    setIds(prev => prev.filter(x => x !== id));
  }, []);

  const clear = useCallback(() => setIds([]), []);

  return (
    <WishlistContext.Provider value={{ ids, count: ids.length, isWishlisted, toggle, remove, clear }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist must be used within WishlistProvider');
  return ctx;
};
